import React from "react";
import { Box, FormControlLabel, Radio } from "@material-ui/core";

const AssignToEntity = ({ assignTo = "job", onSelect, isDisabled }) => {
  return (
    <Box display={"flex"} alignItems="center" mb={2}>
      <FormControlLabel
        value="job"
        disabled={isDisabled}
        checked={assignTo === "job"}
        control={<Radio color="primary" />}
        label="Assign to Job"
        onClick={() => onSelect("job")}
      />
      <FormControlLabel
        value="company"
        checked={assignTo === "company"}
        disabled={isDisabled}
        control={<Radio color="primary" />}
        label="Assign to company"
        onClick={() => onSelect("company")}
      />
    </Box>
  );
};
export default AssignToEntity;
